import React from 'react';

type BadgeType = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

export default function Badge(props: React.PropsWithChildren<{ type?: BadgeType }>) {
  const badgeType: BadgeType = props.type || 'primary';
  return <span className={`badge badge-${badgeType}`}>{props.children}</span>;
}
